export default __webpack_public_path__ + "static/media/Legend10.11560560.jpeg";